// eslint-disable-next-line no-restricted-imports
import { enableMapSet, setAutoFreeze } from 'immer';

// Auto freeze causes problems in developer mode
// when passing data from server to client components
setAutoFreeze(false);
enableMapSet();

// eslint-disable-next-line no-restricted-imports
export * from 'immer';
